import React, { useContext} from "react";
import { Redirect, Route } from "react-router-dom";
import {Context} from '../contexts/Account'
function PrivateRoute({ component: Component, ...rest }) {
    const { loginAccount } = useContext(Context);
    return (
        <Route {...rest}
            render={(props) => {
                if (loginAccount) {
                    return (
                        <Component  {...props} />
                    )
                } else {
                    return(
                        <Redirect to={{
                            pathname: "/",
                            state: {
                                from: props.location
                            }
                        }} />
                    )
                }
            }} />
    )
}
export default PrivateRoute;